// eslint-disable-next-line import/prefer-default-export
export const invitationStatusIds = {
  PENDING: 0,
  ACCEPTED: 1,
  DECLINED: 2,
  VOIDED: 3,
};
